"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const RewardDefinition_1 = require("./RewardDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    channelId: zod_1.z.string((0, validation_1.labelZodErrors)("Channel")).min(1, "Channel is required."),
});
exports.default = new RewardDefinition_1.RewardDefinition("POST_SLACK_MESSAGE", configSchema, zod_1.z.object({}), new validation_1.ValidatorPipeline("PostSlackMessageConfig", [
    (0, validation_1.createAppLinkedValidator)("slack"),
    (0, validation_1.createZodSchemaValidator)(["config"], configSchema),
]), validation_1.NO_OP_VALIDATOR);
//# sourceMappingURL=POST_SLACK_MESSAGE.js.map